import { publishActivityThrottled } from '@/utils/auth-tab-sync';

/** Idle timeout before automatic WL logout (CapHQ parity). */
export const IDLE_TIMEOUT_MS = 10 * 60 * 1000;
const IDLE_CHECK_MS = 30 * 1000;

const ACTIVITY_EVENTS: (keyof WindowEventMap)[] = [
  'mousemove',
  'mousedown',
  'keydown',
  'touchstart',
  'scroll',
  'wheel',
];

export const WL_ACTIVITY_EVENT = 'wl:user-activity';

export function bumpIdleActivity(options?: { sync?: boolean }) {
  window.dispatchEvent(new Event(WL_ACTIVITY_EVENT));
  if (options?.sync !== false) {
    publishActivityThrottled();
  }
}

/**
 * Start idle monitoring. Returns a cleanup function.
 * Activity is synced across tabs so a background tab does not kick an active one.
 */
export function startIdleLogout(
  onIdle: () => void,
  timeoutMs: number = IDLE_TIMEOUT_MS,
): () => void {
  let lastActivity = Date.now();
  let loggedOut = false;

  const onRemoteOrApiActivity = () => {
    lastActivity = Date.now();
  };

  const onLocalUserActivity = () => {
    lastActivity = Date.now();
    publishActivityThrottled();
  };

  const onTick = () => {
    if (loggedOut) return;
    if (Date.now() - lastActivity < timeoutMs) return;
    loggedOut = true;
    onIdle();
  };

  for (const event of ACTIVITY_EVENTS) {
    window.addEventListener(event, onLocalUserActivity, { passive: true });
  }
  window.addEventListener(WL_ACTIVITY_EVENT, onRemoteOrApiActivity);
  const intervalId = window.setInterval(onTick, IDLE_CHECK_MS);

  return () => {
    window.clearInterval(intervalId);
    for (const event of ACTIVITY_EVENTS) {
      window.removeEventListener(event, onLocalUserActivity);
    }
    window.removeEventListener(WL_ACTIVITY_EVENT, onRemoteOrApiActivity);
  };
}
